import React, { useEffect, useState } from "react";
import { getMe } from "../api/authApi";

export default function MyProfile() {
  const [me, setMe] = useState(null);

  useEffect(() => {
    getMe()
      .then((res) => setMe(res.user ?? res))
      .catch(() => setMe(null));
  }, []);

  if (!me) return <div style={{ padding: 20 }}>로딩 중...</div>;

  return (
    <div style={{ padding: 20, maxWidth: 600 }}>
      <h2>내 정보</h2>

      <table style={{ width: "100%", marginTop: 16 }}>
        <tbody>
          <tr>
            <td style={{ fontWeight: 600 }}>이메일</td>
            <td>{me.email}</td>
          </tr>
          <tr>
            <td style={{ fontWeight: 600 }}>이름</td>
            <td>{me.name}</td>
          </tr>
          <tr>
            <td style={{ fontWeight: 600 }}>권한</td>
            <td>{me.grade}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
